import firebase from 'firebase/app';
import 'firebase/functions';
import defaultEnv from './env.json';

const env = process.env.REACT_APP_ENV || 'dev';

export const firebaseFunctions = firebase
    .initializeApp((defaultEnv as any)[env].firebase)
    .functions();
